import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import _ from 'lodash'
import ProjectTemplate from '@/components/ProjectTemplate'
import { actionTypes } from '@/store/actionTypes'
import CONST from '@/utils/const'
import UserService from '@/services/user.service'

Vue.use(Router)

let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: () => import('@/views/Login/Login'),
            beforeEnter: (to, from, next) => {
                if (store.getters.token) {
                    return next('/')
                }
                else {
                    return next()
                }
            }
        },
        {
            path: '/',
            redirect: '/getting-started',
            component: ProjectTemplate,
            children: [
                {
                    path: 'home',
                    name: 'home',
                    redirect: '/authentication'
                },
                {
                    path: 'getting-started',
                    name: 'started',
                    component: () => import('@/views/Home/Started'),
                    meta: {
                        requiresAuth: true
                    }
                }
            ]
        },
        {
            path: '/authentication',
            name: 'Authentication',
            component: () => import('@/views/Authentication/Authentication.vue')
        },
        {
            path: '/authentication-failed',
            name: 'AuthenticationFailed',
            component: () => import('@/views/Authentication/AuthenticationFailed.vue')
        },
        {
            path: '/project/:project_id',
            name: 'project',
            redirect: '/project/:project_id/dashboard',
            component: ProjectTemplate,
            beforeEnter: async (to, from, next) => {
                if (to.params.project_id !== undefined) {
                    if (to.params.project_id !== store.getters.currentProjectId) {
                        store.dispatch(actionTypes.user.CURRENT_PROJECT_ID, to.params.project_id)
                    }
                    next()
                } else {
                    store.dispatch(actionTypes.user.CURRENT_PROJECT_ID, '')
                    next({
                        path: '/404'
                    })
                    return false
                }
            },
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    path: 'dashboard',
                    name: 'dashboard',
                    component: () => import('@/views/Dashboard/Dashboard.vue')
                },
                {
                    path: 'dashboard/:api',
                    name: 'dashboardDetail',
                    component: () => import('@/views/Dashboard/ApiDashboard')
                },
                {
                    path: 'apis',
                    name: 'apis',
                    component: () => import('@/views/APIs/APIList')
                },
                {
                    path: 'apis/:apiKeyId',
                    name: 'apisDetail',
                    component: () => import('@/views/APIs/ApiDetails')
                },
                {
                    path: 'credentials',
                    name: 'credentials',
                    component: () => import('@/views/Credentials/Credentials.vue')
                },
                {
                    path: 'history',
                    name: 'history',
                    component: () => import('@/views/History/APIReports.vue')
                },
                {
                    path: 'details',
                    name: 'details',
                    component: () => import('@/views/Project/ProjectDetails.vue')
                }
            ]
        },
        {
            name: 'application',
            path: '/application',
            redirect: '/application/list',
            component: ProjectTemplate,
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    path: 'list',
                    name: 'listApplication',
                    component: () => import('@/views/ContactUs/ContactUs')
                },
                {
                    path: 'chatbot',
                    name: 'chatbot',
                    component: () => import('@/views/Application/ApplicationDetails')
                },
                {
                    path: 'reader',
                    name: 'reader',
                    component: () => import('@/views/Application/ApplicationDetails')
                },
                {
                    path: 'voicemaker',
                    name: 'voicemaker',
                    component: () => import('@/views/Application/ApplicationDetails')
                }
            ]
        },
        {
            path: '/apis/:api',
            component: ProjectTemplate,
            children: [
                {
                    path: '',
                    name: 'api-detail',
                    component: () => import('@/views/Home/ApiOverview'),
                    meta: {
                        requiresAuth: false
                    }
                }
            ]
        },
        {
            path: '/payment/verify',
            name: 'payment-verify',
            component: () => import('@/views/Payment/VerifyOrder.vue')
        },
        {
            path: '/payment',
            component: ProjectTemplate,
            children: [
                {
                    path: 'history',
                    name: 'payment-history',
                    component: () => import('@/views/Payment/PaymentHistory.vue'),
                    meta: {
                        requiresAuth: true
                    }
                }
            ]
        },
        {
            path: '/contact-us',
            component: ProjectTemplate,
            children: [
                {
                    path: '',
                    name: 'contact-us',
                    component: () => import('@/views/ContactUs/ContactUs'),
                    meta: {
                        requiresAuth: true
                    }
                }
            ]
        },
        {
            path: '/feedback',
            component: ProjectTemplate,
            children: [
                {
                    path: '',
                    name: 'feedback',
                    component: () => import('@/views/Feedback/Feedback'),
                    meta: {
                        requiresAuth: true
                    }
                }
            ]
        },
        {
            path: '/analytics',
            component: ProjectTemplate,
            meta: {
                requiresAuth: true,
                roles: [CONST.roles.MARKETING, CONST.roles.SALE]
            },
            children: [
                {
                    path: 'general',
                    name: 'analytics-general',
                    component: () => import('@/views/Analytics/GeneralAnalytics')
                },
                {
                    path: 'user',
                    name: 'analytics-user',
                    component: () => import('@/views/Analytics/UserStatistic')
                },
                {
                    path: 'project',
                    name: 'analytics-project',
                    component: () => import('@/views/Analytics/ProjectStatistic')
                }
            ]
        },
        {
            path: '/sales',
            component: ProjectTemplate,
            meta: {
                requiresAuth: true,
                roles: [CONST.roles.SALE]
            },
            children: [
                {
                    path: '',
                    name: 'sales',
                    component: () => import('@/views/Sales/Sales')
                },
                {
                    path: 'user/:userId/packages',
                    name: 'sales-user',
                    component: () => import('@/views/Sales/SalesUser')
                },
                {
                    path: 'user/:userId/packages/:packageId',
                    name: 'PostPaidPackageDetails',
                    component: () => import('@/views/Sales/PostPaidPackageDetails')
                },
                {
                    path: 'user/:userId/packages/gantt',
                    name: 'sales-user-gantt',
                    component: () => import('@/views/Sales/GanttPackage')
                }
            ]
        },
        {
            path: '/post-paid-package',
            component: ProjectTemplate,
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    path: '',
                    name: 'post-paid-package-history',
                    component: () => import('@/views/Package/PostPaidPackageHistory')
                }
            ]
        },
        {
            path: '/access-denied',
            name: 'AccessDenied',
            component: () => import('@/modules/fptai/views/AccessDenied/AccessDenied')
        },
        {
            path: '**',
            component: () => import('@/modules/fptai/views/NotFound/NotFound')
        },
    ]
})

if (process.env.NODE_ENV === CONST.env.DEV) {
    router.addRoutes([{
        path: '/sandbox',
        name: 'sandbox',
        component: () => import('@/sandbox/Sandbox')
    }])
}

// Global navigation guard.
router.beforeEach(async (to, from, next) => {
    let guard = true
    // verify authentication 
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters.token) {
            guard = false
            // Redirect to the vue login page
            store.dispatch(actionTypes.user.SIGN_IN, window.location.href)
        }
    }
    if (!guard) {
        return
    }
    // verify role
    if (to.matched.some(record => Array.isArray(record.meta.roles) && record.meta.roles.length > 0)) {
        let userRoles = null
        if (store.state.user.isProfileLoaded) {
            userRoles = store.state.user.roles
        } else {
            try {
                let profileRes = await UserService.getProfile()
                userRoles = profileRes.data.roles
            } catch (e) {
                router.push({ name: 'AuthenticationFailed' })
            }
        }
        if (Array.isArray(userRoles)) {
            for (let record of to.matched) {
                let routeRoles = record.meta.roles
                if (Array.isArray(routeRoles) && routeRoles.length > 0) {
                    if (_.difference(userRoles, routeRoles).length === userRoles.length) {
                        guard = false
                        router.push({ name: 'AccessDenied' })
                        break
                    }
                }
            }
        } else {
            guard = false
        }
    }
    // continue if all conditions passed
    if (guard) {
        next()
    }
})

export default router
